<template>
  <DialogBase
    v-model="inputedValue"
    :title="$t('user.user_add-member')"
    :width="width"
    isPadding0="true"
  >
    <v-card class="content">
      <v-row align="center">
        <v-col class="labelCol"
          >{{ $t('common.input_mailaddress') }}&nbsp;<RequiredLabel
        /></v-col>
      </v-row>
      <v-row align="center">
        <v-col>
          <v-text-field
            v-model="inputData.email"
            :placeholder="$t('common.input_mailaddress')"
            outlined
            dense
            hide-details
            :height="inputItemHeight"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="labelCol"
          >{{ $t('common.input_name') }}&nbsp;<RequiredLabel
        /></v-col>
      </v-row>
      <v-row align="center">
        <v-col>
          <NameTextBoxArea v-model="inputData.name" :height="inputItemHeight" />
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="labelCol">{{ $t('user.user_role') }}</v-col>
      </v-row>
      <v-row align="center">
        <v-col>
          <SelectUserAuthority
            v-model="inputData.authority"
            @change="inputData.authority = $event"
          />
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col>
          <NormalLink
            :text="$t('user.user_about-member-auth')"
            :isBlank="true"
            link="https://spe-s.jp/manual/member/"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <NormalButton
            :text="$t('user.user_send-an-invitation-email')"
            height="50px"
            textSize="16px"
            @click="submit"
            :disabled="
              inputData.email.length === 0 ||
              inputData.name.lastName.length === 0 ||
              inputData.name.firstName.length === 0
            "
          />
        </v-col>
      </v-row>
    </v-card>
  </DialogBase>
</template>
<script>
import { mapActions } from 'vuex'
import DialogBase from './DialogBase'
import NormalButton from '@/components/items/Buttons/NormalButton'
import { SelectUserAuthority } from '@/components/items/Selectboxes'

import { authorityConfig } from '@/config'
import { masterUtil } from '@/util'
import RequiredLabel from '@/components/items/Labels/RequiredLabel'
import NameTextBoxArea from '@/components/items/Designs/NameTextBoxArea'
import NormalLink from '@/components/items/Links/NormalLink'

export default {
  components: {
    DialogBase,
    RequiredLabel,
    NormalButton,
    SelectUserAuthority,
    NameTextBoxArea,
    NormalLink
  },
  props: {
    value: {
      dialog: false
    },
    width: { default: '360px' }
  },
  data: () => ({
    inputItemHeight: '32px',
    inputData: {
      email: '',
      name: { lastName: '', firstName: '' },
      authority: {}
    }
  }),

  methods: {
    ...mapActions('User', ['inviteUser']),

    init() {
      const tmp = {
        email: '',
        name: { lastName: '', firstName: '' },
        authority: masterUtil
          .getAuthorityList()
          .find((ele) => authorityConfig.AUTHORITY_TYPE_ID.USER === ele.value)
      }

      this.inputData = tmp
    },

    async submit() {
      const success = await this.inviteUser(this.inputData)
      if (success) {
        alert(this.$t('user.user_invitation-email-was-sent'))
        this.$emit('add')
        this.inputedValue = false
      }
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    inputedValue: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) this.init()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  padding: 30px !important;
}
.labelCol {
  padding-bottom: 0px;
}
</style>
